module.exports = "/images/vendor/flag-icon-css/flags/1x1/kn.svg?4ad12564dce8cd72eac5f2761c8bf03d";